import {environment} from '../../config/environment';
import {api} from '../../shared/utils';

const authBaseUrl = `${environment.apiBaseURLClients}/auth`;

// O identity entra por e-mail. Quem ainda manda `username` (formato antigo) tem o valor tratado
// como e-mail. O BFAUTO-77 tinha desfeito isso sem querer, e o teste acusava.
export const loginPortalClient = async (credentials = {}) => {
    const email = credentials.email || credentials.username || '';
    const {password} = credentials;

    if (environment.disableAuth) {
        return {
            username: 'demo',
            name: 'Cliente Demo',
            email: email || 'demo@busifarm.com.br',
            accessToken: 'demo-token',
            expiresIn: Date.now() + 24 * 60 * 60 * 1000,
            tenantId: 'tenant-demo',
            companyId: 'company-demo',
        };
    }

    const loginPayload = {
        username: email,
        email,
        password,
    };

    // Incluir systemId no payload se estiver configurado
    if (environment.systemId) {
        loginPayload.systemId = environment.systemId;
    }

    const response = await api.post(`${authBaseUrl}/login`, loginPayload);

    return response?.data?.data ?? response?.data?.valor ?? response?.data ?? {};
};